import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.articulationGymnasticsLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.articulationGymnasticsLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) =>
    state.articulationGymnasticsLevels.data.articulationGymnasticsLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
